import { SELECT_EVENT, EVENT_FETCH, EVENT_FETCH_SUCCESS, EVENT_FETCH_FAIL, EVENTS_FETCH, EVENTS_FETCH_SUCCESS, EVENTS_FETCH_FAIL, PARTNER_PORTAL_SETTINGS_FETCH, PARTNER_PORTAL_SETTINGS_FETCH_SUCCESS, PARTNER_PORTAL_SETTINGS_FETCH_FAIL } from '../constants/ActionTypes';

export const selectEvent = event => {
  return {
    type: SELECT_EVENT,
    event
  };
};

export const eventFetch = (eventID, partnerID) => {
  return {
    type: EVENT_FETCH,
    eventID,
    partnerID
  };
};

export const eventFetchSuccess = event => {
  return {
    type: EVENT_FETCH_SUCCESS,
    event
  };
};

export const eventFetchFail = error => {
  return {
    type: EVENT_FETCH_FAIL,
    error
  };
};

export const eventsFetch = userID => {
  return {
    type: EVENTS_FETCH,
    userID
  }
};

export const eventsFetchSuccess = events => {
  return {
    type: EVENTS_FETCH_SUCCESS,
    events
  }
};

export const eventsFetchFail = error => {
  return {
    type: EVENTS_FETCH_FAIL,
    error
  }
}

export const partnerPortalSettingsFetch = eventID => {
  return {
    type: PARTNER_PORTAL_SETTINGS_FETCH,
    eventID
  }
}

export const partnerPortalSettingsFetchSuccess = partnerPortalSettings => {
  return {
    type: PARTNER_PORTAL_SETTINGS_FETCH_SUCCESS,
    partnerPortalSettings
  }
};

export const partnerPortalSettingsFetchFail = error => {
  return {
    type: PARTNER_PORTAL_SETTINGS_FETCH_FAIL,
    error
  }
}